query StreamClips($contentId: ID!) {
  streamClips(contentId: $contentId) {
    startSeconds
    durationSeconds
    previewUrl
    downloadUrl
    content {
      id
      title
      publishAt
      duration
      transcodingError
      preview {
        url(format: SMALL)
      }
      playback {
        thumbnailUrl
      }
      video {
        id
        readyToStream
      }
    }
  }
}
